import { render, staticRenderFns } from "./DetectionSetsCompact.vue?vue&type=template&id=29ed8cd4&scoped=true&"
import script from "./DetectionSetsCompact.vue?vue&type=script&lang=js&"
export * from "./DetectionSetsCompact.vue?vue&type=script&lang=js&"
import style0 from "./DetectionSetsCompact.vue?vue&type=style&index=0&id=29ed8cd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed8cd4",
  null
  
)

export default component.exports